if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      // Was scoped to [data-media-id], but images also add 'active' to their
      // .product__media-container wrapper (below), which has no data-media-id
      // — that wrapper never got cleared and stayed 'active' across every
      // later open, so .active could match a stale image from a previous
      // colour instead of (or alongside) the current one.
      this.querySelectorAll('.active').forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaContainer = activeMedia.closest('.product__media-container');
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMediaContainer.classList.add('active');

      // Must run before scrollIntoView(): a hidden (display:none) element left
      // over from the previous colour's filter has no layout box, so scrolling
      // to it is a no-op — the modal then opens at whatever scroll position
      // was left over from the last time it was open for a different colour.
      // data-sku lives on the top-level media element for video/model, but on
      // its .product__media-container wrapper for images (see product-media
      // .liquid) — closest() covers both since it checks the element itself too.
      this.filterByColor(activeMedia.closest('[data-sku]')?.dataset.sku);

      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    // Desktop shows every media item of the opened colour stacked/scrollable
    // (by design, see product-media-modal__content CSS); restrict that set to
    // the colour that was clicked instead of every colour in the product.
    filterByColor(sku) {
      if (!sku) return;
      const modifiedSku = sku.replace('XX', '');
      this.querySelectorAll('.product-media-modal__content > [data-sku]').forEach((element) => {
        const elementSku = element.dataset.sku;
        const matches = elementSku === sku || elementSku === modifiedSku;
        element.style.display = matches ? '' : 'none';
      });
    }
  });
}
